<template>
	<div class="productcard__bottom--buyonclick">
		<a
			class="button"
			ref="productorder"
			:href="'/include/productorder.php?productId=' + productId"
			v-html="loc.PRODUCT_ORDER_CLICK_BTN"
		></a>
	</div>
</template>

<script>

import {Vue} from "ui.vue";

export default {
	name: "CitrusProductBuyOnClick",
	props: {
		productId: {
			type: [Number, Boolean],
			default: false,
		}
	},
	data: function () {
		let data = {
		};
		return data;
	},
	computed: {
		loc() {
			return Object.freeze(Vue.getFilteredPhrases("PRODUCT_ORDER_CLICK_"));
		}
	},
	created: function () {

	},
	mounted: function () {
		$(this.$refs.productorder).magnificPopup({
			closeOnContentClick: false,
			closeOnBgClick: false,
			showCloseBtn: false,
			enableEscapeKey: true,
			type: 'ajax',
			callbacks: {
				ajaxContentAdded: function() {
					var m = this;
					this.content.find('.modal-close').on('click', function(e) {
						e.preventDefault();
						m.close();
					});
				}
			},
		});
	},
	methods: {
		toDetailPage: function () {

		}
	}
};
</script>
